<template>
  <div class="tissue">

    <div class="a-row heading">
      <div class="first">{{$ml.get(`TEST NAME`)}}</div>
      <!-- <div class="second">{{$ml.get(`LAB NAME`)}}</div> -->
      <div class="third">{{$ml.get(`TEST DATE`)}}</div>
    </div>

    <app-loading :loading="loading">
      <div class="a-row test" v-for="(item, i) in tissueTests"
        :key="i"
        @click="addTestToProgram(item.id)"
        :class="{is_active : item.id == tissueTestId}"
      >
        <div class="first">{{ item.name }}</div>
        <!-- <div class="second">{{ 'lab name' }}</div> -->
        <div class="third">
          {{ item.date }}
          <button
            @click.stop="removeTest()"
            class="remove-test"
            v-if="item.id == tissueTestId"
          >
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>
    </app-loading>
  </div>
</template>

<script>
import API from '@/api';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: false,
    }
  },
  methods : {
    addTestToProgram(id) {
      this.$store.dispatch('program/tests/addTissueTest', id).then(res => {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Test was successfully added to current program!`),
          type : 'success',
        });
        this.$emit('loadProgram');
      });
    },
    removeTest() {
      this.$store.dispatch('program/tests/removeTest', 'tissue').then(res => {
        this.$emit('loadProgram');
      });
    },
  },
  created() {
    this.loading = true;
    this.$store.dispatch('program/tests/setTissueTests')
      .finally(() => {
        this.loading = false
      });
  },
  computed: {
    ...mapGetters({
      tissueTests: 'program/tests/tissueTests',
      tissueTestId: 'program/tests/tissueTestId',
    }),
  }
}
</script>

<style lang="scss" scoped>

.app-loading {
  min-height: 100px;
}

</style>
